import { ACTIONS } from "../../../Models/ENUM";
import DATE from "../../../UTIL/DATE";
import TimerInstance from "../../../UTIL/Instances/TimerInstance";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import GameCurrency from "../WALLET/GameCurrency";
import Shop from "./Shop";
import ShopTab from "./ShopTab";
import InventoryItem from "../INVENTORY/InventoryItem";
import LOG, { log } from "../../../UTIL/LOG";
import ARRAY from "../../../UTIL/ARRAY";


class ShopItem
{
    private Shop            : Shop;
    public key              : string;
    public price            : any;
    private _price          : number;
    public currency         : string;
    public title            : string;
    public ad               : string;
    public amount           : number;
    public metadata         : any;
    public id               : any;
    public data             : any;
    public tabKey           : any;
    public description      : string;
    public iap              : string;
    public symbol           : string;
    public timer            : number;
    public type             : string;
    public value            : any;
    public variable         : any;
    public rarity           : string;
    public sorting          : number = 0;
 
    public canLevelUp       : boolean;
    public levelUpCurrency  : string;
    public level            : number = 0;
    public quantity         : number = 0;
    public priceLevelUp     : number;
    private _priceLevelUp   : number;
    public multiplier       : number = 1;
 
    private quantityKey     : string;
    private levelKey        : string;
    public min              : number = 0;
    public max              : number = 1;
    public isMaxxed         : boolean = false;
 
    private Timer           : any | TimerInstance;
    private lastCollected   : number = 0;

    public canCollect       : boolean = false;

    private gameInstance    : GameInstance;
 
    public currSymbol       : string = "";
    public onRefresh        : Function = function(){};
 
    constructor( gameInstance:GameInstance, vars:any )
    {
        this.gameInstance       = gameInstance;
        this.Shop               = gameInstance.Shop;

        this.tabKey             = vars.tabKey;
        this.key                = vars.key;
        this.id                 = vars._id;

        let data                = this.data = vars.data;

        this._price             = data.price;
        this.price              = this._price;
        
        this.currency           = data.currency;
        this.title              = data.title;
        this.ad                 = data.ad;
        this.amount             = data.amount || 0;
        this.metadata           = data.metadata;
        this.rarity             = data.rarity;
 
        this.description        = data.description;

        this.canLevelUp         = data.canLevelUp;
        this.levelUpCurrency    = data.levelUpCurrency || this.currency;
        this.isMaxxed           = false;
        this._priceLevelUp      = data.priceLevelUp || this.price;
        this.priceLevelUp       = this._priceLevelUp;

        this.quantityKey        = "$Q_" + this.key;
        this.levelKey           = "$L_" + this.key;

        this.quantity           = this.gameInstance.Data.data[ this.quantityKey ] || ( data.autoEquip ? 1 : 0 );
        this.level              = this.gameInstance.Data.data[ this.levelKey ] || 1;

        if( this.Shop.tabs[ this.tabKey ] )
        {
            if( !this.description ) this.description = this.Shop.tabs[ this.tabKey ].description;
        }else{
            log( "ERROR, missing shop tab", this.tabKey );
        }
 
        this.iap            = data.iap;
        this.symbol         = data.symbol = data.symbol || this.key;
        this.timer          = data.timer || 0;
        this.type           = data.type;
        this.value          = data.value;
        this.variable       = data.variable;
 
        let Shop            = this.Shop;

        Shop.items[ this.key ]  = this;

        if( this.type == "Inventory" ) Shop.inventory.push( this );

        let tab : ShopTab       = Shop.tabs[ this.tabKey ];
        if( tab ) tab.items.push( this );
 
        if( this.timer > 0 && this.currency != "Ad" )
        {
            this.lastCollected  = this.gameInstance.Data.data[ this.key ] || 0;
            if( !this.lastCollected ) this.lastCollected = this.gameInstance.Data.set( this.key, DATE.now() );

            let self    = this;
            this.Timer  = new TimerInstance({ id:this.key + "Timer", autoStart:true, duration:this.timer, startTime:this.lastCollected, Signal:gameInstance.Signal, onTimeUp:function(){ self.refresh()  }}); 
        }

        this.refresh();
    }

    public refresh()
    {
        this.canCollect     = this.currency == "Ad" || ( this.Timer && this.Timer.remaining <= 0 );

        if( this.canCollect )
        {
            this.price      = "GET";
            this.currSymbol = "Symbol_Ad";

            if( this.onRefresh ) this.onRefresh();

            return;
        }

        this.refreshLevel();

        this.currSymbol     = "Symbol_" + this.currency;
 
        if( this.onRefresh ) this.onRefresh();

      //  if( this.Timer ) //log( this.key, "REFRESH lastCollected", this.gameInstance.Data.data[ this.key ], "canCollect", this.canCollect, this.currency, "remaining", this.Timer.remaining );
    }

    public stop()
    {
        if( this.Timer ) this.Timer.stop();
    }

    public async buy() : Promise<any>
    {
        //log("BUY!", this, this.data.value );

        if( this.type === "Inventory" )
        {
            let item : InventoryItem = this.gameInstance.Inventory.items[ this.key ];
            if( !item.isLocked ) return Promise.resolve( false );
        }

        var isPurchased : boolean = false;

        if( this.canCollect ) 
        {
            this.lastCollected  = this.gameInstance.Data.set( this.key, DATE.now() );
            isPurchased         = true;

            if( this.Timer ) this.Timer.start();

        }else{
            
            let success = await this.doPurchase();
            if( !success ) return Promise.resolve( false );

            isPurchased = true;

            this.gameInstance.Signal.set( "onPurchase" );
        }

        if( isPurchased ) 
        {
            this.gameInstance.Analytics.onPurchase( this.key );
        }

        let results = this.set( isPurchased );
 
        this.refresh();
 
        return Promise.resolve( results );
    }

    public set( bool:boolean )
    {
        //log("SET", bool );

        if( !bool ) return false;
 
        // Inventory 

        if( this.type === "Inventory" )
        {
            let inventoryItem : InventoryItem = this.gameInstance.Inventory.items[ this.key ];
            if( inventoryItem ) inventoryItem.unlock();

            if( !this.canLevelUp || this.isMaxxed ) return false;

            this.quantity = this.gameInstance.Data.increase( this.quantityKey, 1 );
 
            this.refresh();

            return true;
        }

        // Wallet

        let currencyInstance : GameCurrency = this.gameInstance.Wallet.currencies[ this.variable ];
        if( currencyInstance ) 
        {
            currencyInstance.increase( this.amount );
            return this.amount;
        }
        
        // Timewarp

        if( this.variable === "TimeWarp" ) return true;

        // Lootbox

        if( this.variable === "Lootbox" )
        {
            //log("Its a lootbox", this.value );
            if( !this.value ) return false;

            for( let n in this.value.currencies )
            {
                
                let item = this.value.currencies[n];
                //log("had currency", item );
                let currencyInstance : GameCurrency = this.gameInstance.Wallet.currencies[ item.currency ];

                if( currencyInstance )
                {
                    //log("currency increased" );
                    currencyInstance.increase( item.amount );
                    continue;
                }

                if( item.currency == "userXP" )
                {
                    //log("userXP increased" );
                    this.gameInstance.UserXP.increase( item.amount );
                    continue;
                }

                //log("increased something else", item.currency );

                this.gameInstance.Data.increase( item.currency, item.amount );
            }

            this.gameInstance.Data.increaseTotal( "OpenLoot" );

            let contentItems = this.gameInstance.Inventory.setLoot( this.value );

            let output = ARRAY.extract( this.value, { items:contentItems });

            return output
        }
 
        // XP

        if( this.variable === "userXP" )
        {
            this.gameInstance.UserXP.increase( this.amount );
            return this.amount;
        }

        // Variables

        if( this.variable && this.amount )
        {   
            this.gameInstance.Data.increase( this.variable, this.amount );
            return this.amount;
        }

        return true;
 
    }

    private async doPurchase( _currency?:any, _price?:number ) : Promise<any> 
    {
        let currencyInstance : GameCurrency = await this.gameInstance.Wallet.getCurrency( _currency || this.currency );

        if( !currencyInstance ) return Promise.resolve( false ); 

        let cashInHand = currencyInstance.value;

        let price : number = _price || this.price;

        if( price > cashInHand ) return Promise.resolve( false ); 

        currencyInstance.decrease( price );

        return Promise.resolve( true ); 
    }
 

    public async buyLevelUp()  : Promise<any>
    {
        if( this.isMaxxed || !this.canLevelUp ) return Promise.resolve();

        let success = await this.doPurchase( this.levelUpCurrency, this.priceLevelUp );
        if( !success ) return Promise.resolve( false );

        this.gameInstance.Data.increase( this.levelKey, 1 );

        this.refresh();

        return Promise.resolve( true );
    }

    private refreshLevel()
    {
        let rarities   = [ "None", "Common", "Rare", "Epic", "Legendary", "Mythic" ]

        this.multiplier = rarities.indexOf( this.rarity );
 
        if( !this.canLevelUp )
        {
            this.level      = 1;
            this.price      = this._price;
            this.isMaxxed   = this.quantity > 0;
            return;
        }
 
        let levelUpTable : any = [ 0, 5, 15, 35, 65 ];

        if( this.level >= levelUpTable.length-1 )
        {
            this.price      = this._price * this.level;
            this.isMaxxed   = true;

            this.multiplier *= this.level;
            return;
        }

        this.isMaxxed       = false;
 
        var newLevel        = 0;
        var min             = levelUpTable[ 0 ];
        var max             = levelUpTable[ 1 ];
        var n;

        for( n=1; n< levelUpTable.length; n++ ) 
        {
            newLevel++;

            min = levelUpTable[n-1];
            max = levelUpTable[n];
 
            if( this.quantity < levelUpTable[n] || ( newLevel >= this.level ) )
            {
                this.max            = max;  
                this.min            = min;
                this.level          = newLevel;
                this.price          = this._price * this.level;
                this.priceLevelUp   = this._priceLevelUp * this.level;
                this.multiplier     *= this.level;

                return;
            }
        }
 
    }

 
 
}

export default ShopItem;